import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const loadApplications = createAsyncThunk(
    'api/applications/{candidate_id}',
    async (id: string) => await api.applications.get(id)
);
